"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_client_service_1 = require("../../../axios-client/axios-client.service");
var chauffeur_const_1 = require("./chauffeur.const");
/**
 * ChauffeurService
 * @class
 */
var ChauffeurService = /** @class */ (function () {
    function ChauffeurService() {
    }
    /**
     * Returns chauffeur's (`chauffeurUuid`) status
     * @param chauffeurUuid {string}
     * @returns ChauffeurDetails
     */
    ChauffeurService.prototype.getChauffeurDetails = function (chauffeurUuid) {
        var url = chauffeur_const_1.CHAUFFEUR_ENDPOINT.getChauffeurDetails.replace('{{chauffeurUuid}}', chauffeurUuid);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Updates a chauffeur's (`chauffeurUuid`) status
     * @param chauffeurUuid {string}
     * @param data<ChauffeurStatus>
     * @returns ChauffeurDetails
     */
    ChauffeurService.prototype.putChauffeurStatus = function (chauffeurUuid, data) {
        var url = chauffeur_const_1.CHAUFFEUR_ENDPOINT.putChauffeurStatus.replace('{{chauffeurUuid}}', chauffeurUuid);
        return axios_client_service_1.axiosClientInstance.put(url, data);
    };
    /**
     * Updates a chauffeur's (`chauffeurUuid`) callsign
     * @param chauffeurUuid {string}
     * @param data<ChauffeurStatus>
     * @returns ChauffeurDetails
     */
    ChauffeurService.prototype.putChauffeurCallsign = function (chauffeurUuid, data) {
        var url = chauffeur_const_1.CHAUFFEUR_ENDPOINT.putChauffeurCallsign.replace('{{chauffeurUuid}}', chauffeurUuid);
        return axios_client_service_1.axiosClientInstance.put(url, data);
    };
    /**
     * Binds a vehicle (`data`) to a chauffeur (`chauffeurUuid`)
     * @param chauffeurUuid {string}
     * @param data
     * @returns ChauffeurDetails
     */
    ChauffeurService.prototype.putVehicleToChauffeur = function (chauffeurUuid, data) {
        var url = chauffeur_const_1.CHAUFFEUR_ENDPOINT.putVehicleToChauffeur.replace('{{chauffeurUuid}}', chauffeurUuid);
        return axios_client_service_1.axiosClientInstance.put(url, data);
    };
    /**
     * Deletes chauffeur documentation
     * @param chauffeurUuid {string}
     * @param documentUuid {string}
     * @returns ChauffeurDetails
     */
    ChauffeurService.prototype.deleteChauffeurDocumentation = function (chauffeurUuid, documentUuid) {
        var url = chauffeur_const_1.CHAUFFEUR_ENDPOINT.deleteChauffeurDocumentation
            .replace('{{chauffeurUuid}}', chauffeurUuid)
            .replace('{{documentUuid}}', documentUuid);
        return axios_client_service_1.axiosClientInstance.delete(url);
    };
    /**
     * Updates chauffeur documentation
     * @param chauffeurUuid {string}
     * @param document {string}
     * @returns ChauffeurDetails
     */
    ChauffeurService.prototype.patchChauffeurDocumentation = function (chauffeurUuid, documentUuid, data, version) {
        if (version === void 0) { version = 'v1'; }
        var url = chauffeur_const_1.CHAUFFEUR_ENDPOINT.patchChauffeurDocumentation
            .replace('{{version}}', version)
            .replace('{{chauffeurUuid}}', chauffeurUuid)
            .replace('{{documentUuid}}', documentUuid);
        return axios_client_service_1.axiosClientInstance.patch(url, data);
    };
    return ChauffeurService;
}());
/**
 * ChauffeurService Class Instance
 * @namespace
 */
exports.chauffeur = new ChauffeurService();
